import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import ListaPresentes from './pages/ListaPresentes';
import ConfirmacaoPresencas from './pages/ConfirmacaoPresencas';
import Cerimonia from './pages/Cerimonia';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/listapresentes" element={<ListaPresentes />} />
          <Route path="/confirmacaopresencas" element={<ConfirmacaoPresencas />} />
          <Route path="/cerimonia" element={<Cerimonia />} />
        </Routes>
      <Footer />
    </Router>
  );
}

export default App;
